/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown>, type: NonNullable<unknown> }} Seat_Change_Intro_MemberInputs */



/**
* | output |
* | --- |
* | "{email} has a {type} seat." |
*
* @param {Seat_Change_Intro_MemberInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_change_intro_member = /** @type {((inputs: Seat_Change_Intro_MemberInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Change_Intro_MemberInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.email} hat einen ${i?.type}-Platz.`)
	return /** @type {LocalizedString} */ (`${i?.email} has a ${i?.type} seat.`)
});